'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

/**
 * A response that represents an error or failure, either from a
 * non-successful Http Socket status, or an error while executing the request.
 *
 * Any error returned on the `Observable` response stream will be
 * wrapped in an `HttpSourceErrorResponse` to provide additional context about
 * the state of the Http long request layer when the error occurred.
 *
 * @export
 * @class HttpSourceErrorResponse
 * @implements {Error}
 */
var HttpSourceErrorResponse = /*#__PURE__*/_createClass__default["default"](function HttpSourceErrorResponse(init) {
  _classCallCheck__default["default"](this, HttpSourceErrorResponse);
  _defineProperty__default["default"](this, "name", 'HttpSourceErrorResponse');
  this.error = init.error;
  this.statusText = 'Error';
  this.status = init.status || 0;
  this.message = "HttpSource failure response with ".concat(this.status);
});

exports.HttpSourceErrorResponse = HttpSourceErrorResponse;
